/**
 * Comprehensive Teams Database
 * Contains teams from all major sports and leagues
 * This allows users to search and follow teams even when they don't have current games
 */

export const TEAMS_DATABASE = [
  // NFL Teams
  {
    name: "Arizona Cardinals",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/ari.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Atlanta Falcons",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/atl.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Baltimore Ravens",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/bal.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Buffalo Bills",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/buf.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Carolina Panthers",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/car.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Chicago Bears",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/chi.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Cincinnati Bengals",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/cin.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Cleveland Browns",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/cle.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Dallas Cowboys",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/dal.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Denver Broncos",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/den.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Detroit Lions",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/det.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Green Bay Packers",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/gb.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Houston Texans",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/hou.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Indianapolis Colts",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/ind.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Jacksonville Jaguars",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/jax.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Kansas City Chiefs",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/kc.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Las Vegas Raiders",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/lv.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Los Angeles Chargers",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/lac.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Los Angeles Rams",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/lar.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Miami Dolphins",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/mia.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Minnesota Vikings",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/min.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "New England Patriots",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/ne.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "New Orleans Saints",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/no.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "New York Giants",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/nyg.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "New York Jets",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/nyj.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Philadelphia Eagles",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/phi.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Pittsburgh Steelers",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/pit.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "San Francisco 49ers",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/sf.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Seattle Seahawks",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/sea.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Tampa Bay Buccaneers",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/tb.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Tennessee Titans",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/ten.png",
    sport: "American Football",
    league: "NFL",
  },
  {
    name: "Washington Commanders",
    logo: "https://a.espncdn.com/i/teamlogos/nfl/500/wsh.png",
    sport: "American Football",
    league: "NFL",
  },

  // NBA Teams
  {
    name: "Atlanta Hawks",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/atl.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Boston Celtics",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/bos.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Brooklyn Nets",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/bkn.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Charlotte Hornets",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/cha.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Chicago Bulls",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/chi.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Cleveland Cavaliers",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/cle.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Dallas Mavericks",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/dal.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Denver Nuggets",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/den.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Detroit Pistons",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/det.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Golden State Warriors",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/gs.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Houston Rockets",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/hou.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Indiana Pacers",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/ind.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Los Angeles Clippers",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/lac.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Los Angeles Lakers",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/lal.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Memphis Grizzlies",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/mem.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Miami Heat",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/mia.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Milwaukee Bucks",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/mil.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Minnesota Timberwolves",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/min.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "New Orleans Pelicans",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/no.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "New York Knicks",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/ny.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Oklahoma City Thunder",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/okc.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Orlando Magic",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/orl.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Philadelphia 76ers",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/phi.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Phoenix Suns",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/phx.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Portland Trail Blazers",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/por.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Sacramento Kings",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/sac.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "San Antonio Spurs",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/sa.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Toronto Raptors",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/tor.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Utah Jazz",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/utah.png",
    sport: "Basketball",
    league: "NBA",
  },
  {
    name: "Washington Wizards",
    logo: "https://a.espncdn.com/i/teamlogos/nba/500/wsh.png",
    sport: "Basketball",
    league: "NBA",
  },

  // NHL Teams
  {
    name: "Anaheim Ducks",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/ana.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Arizona Coyotes",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/ari.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Boston Bruins",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/bos.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Buffalo Sabres",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/buf.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Calgary Flames",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/cgy.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Carolina Hurricanes",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/car.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Chicago Blackhawks",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/chi.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Colorado Avalanche",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/col.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Columbus Blue Jackets",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/cbj.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Dallas Stars",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/dal.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Detroit Red Wings",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/det.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Edmonton Oilers",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/edm.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Florida Panthers",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/fla.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Los Angeles Kings",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/la.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Minnesota Wild",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/min.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Montreal Canadiens",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/mtl.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Nashville Predators",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/nsh.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "New Jersey Devils",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/njd.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "New York Islanders",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/nyi.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "New York Rangers",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/nyr.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Ottawa Senators",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/ott.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Philadelphia Flyers",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/phi.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Pittsburgh Penguins",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/pit.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "San Jose Sharks",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/sj.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Seattle Kraken",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/sea.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "St. Louis Blues",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/stl.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Tampa Bay Lightning",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/tb.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Toronto Maple Leafs",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/tor.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Vancouver Canucks",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/van.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Vegas Golden Knights",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/vgk.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Washington Capitals",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/wsh.png",
    sport: "Ice Hockey",
    league: "NHL",
  },
  {
    name: "Winnipeg Jets",
    logo: "https://a.espncdn.com/i/teamlogos/nhl/500/wpg.png",
    sport: "Ice Hockey",
    league: "NHL",
  },

  // MLB Teams
  {
    name: "Arizona Diamondbacks",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/ari.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Atlanta Braves",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/atl.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Baltimore Orioles",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/bal.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Boston Red Sox",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/bos.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Chicago Cubs",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/chc.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Chicago White Sox",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/chw.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Cincinnati Reds",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/cin.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Cleveland Guardians",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/cle.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Colorado Rockies",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/col.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Detroit Tigers",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/det.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Houston Astros",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/hou.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Kansas City Royals",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/kc.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Los Angeles Angels",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/laa.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Los Angeles Dodgers",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/lad.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Miami Marlins",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/mia.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Milwaukee Brewers",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/mil.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Minnesota Twins",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/min.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "New York Mets",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/nym.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "New York Yankees",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/nyy.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Oakland Athletics",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/oak.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Philadelphia Phillies",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/phi.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Pittsburgh Pirates",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/pit.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "San Diego Padres",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/sd.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "San Francisco Giants",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/sf.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Seattle Mariners",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/sea.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "St. Louis Cardinals",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/stl.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Tampa Bay Rays",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/tb.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Texas Rangers",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/tex.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Toronto Blue Jays",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/tor.png",
    sport: "Baseball",
    league: "MLB",
  },
  {
    name: "Washington Nationals",
    logo: "https://a.espncdn.com/i/teamlogos/mlb/500/wsh.png",
    sport: "Baseball",
    league: "MLB",
  },

  // NCAAF Teams (Major College Football Programs)
  {
    name: "Alabama Crimson Tide",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/333.png",
    sport: "NCAAF",
    league: "SEC",
  },
  {
    name: "Georgia Bulldogs",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/61.png",
    sport: "NCAAF",
    league: "SEC",
  },
  {
    name: "Ohio State Buckeyes",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/194.png",
    sport: "NCAAF",
    league: "Big Ten",
  },
  {
    name: "Michigan Wolverines",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/130.png",
    sport: "NCAAF",
    league: "Big Ten",
  },
  {
    name: "Texas Longhorns",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/251.png",
    sport: "NCAAF",
    league: "SEC",
  },
  {
    name: "Oklahoma Sooners",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/201.png",
    sport: "NCAAF",
    league: "SEC",
  },
  {
    name: "LSU Tigers",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/99.png",
    sport: "NCAAF",
    league: "SEC",
  },
  {
    name: "Clemson Tigers",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/228.png",
    sport: "NCAAF",
    league: "ACC",
  },
  {
    name: "Penn State Nittany Lions",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/213.png",
    sport: "NCAAF",
    league: "Big Ten",
  },
  {
    name: "USC Trojans",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/30.png",
    sport: "NCAAF",
    league: "Big Ten",
  },
  {
    name: "Notre Dame Fighting Irish",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/87.png",
    sport: "NCAAF",
    league: "FBS",
  },
  {
    name: "Florida Gators",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/57.png",
    sport: "NCAAF",
    league: "SEC",
  },
  {
    name: "Auburn Tigers",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/2.png",
    sport: "NCAAF",
    league: "SEC",
  },
  {
    name: "Oregon Ducks",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/2483.png",
    sport: "NCAAF",
    league: "Big Ten",
  },
  {
    name: "Tennessee Volunteers",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/2633.png",
    sport: "NCAAF",
    league: "SEC",
  },
  {
    name: "Texas A&M Aggies",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/245.png",
    sport: "NCAAF",
    league: "SEC",
  },
  {
    name: "Florida State Seminoles",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/52.png",
    sport: "NCAAF",
    league: "ACC",
  },
  {
    name: "Wisconsin Badgers",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/275.png",
    sport: "NCAAF",
    league: "Big Ten",
  },
  {
    name: "Miami Hurricanes",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/2390.png",
    sport: "NCAAF",
    league: "ACC",
  },
  {
    name: "Washington Huskies",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/264.png",
    sport: "NCAAF",
    league: "Big Ten",
  },
  {
    name: "Ole Miss Rebels",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/145.png",
    sport: "NCAAF",
    league: "SEC",
  },
  {
    name: "Oklahoma State Cowboys",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/197.png",
    sport: "NCAAF",
    league: "Big 12",
  },
  {
    name: "Iowa Hawkeyes",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/2294.png",
    sport: "NCAAF",
    league: "Big Ten",
  },
  {
    name: "Utah Utes",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/254.png",
    sport: "NCAAF",
    league: "Big 12",
  },
  {
    name: "Baylor Bears",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/239.png",
    sport: "NCAAF",
    league: "Big 12",
  },
  {
    name: "Arkansas Razorbacks",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/8.png",
    sport: "NCAAF",
    league: "SEC",
  },
  {
    name: "Kentucky Wildcats",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/96.png",
    sport: "NCAAF",
    league: "SEC",
  },
  {
    name: "North Carolina Tar Heels",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/153.png",
    sport: "NCAAF",
    league: "ACC",
  },
  {
    name: "Michigan State Spartans",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/127.png",
    sport: "NCAAF",
    league: "Big Ten",
  },
  {
    name: "Nebraska Cornhuskers",
    logo: "https://a.espncdn.com/i/teamlogos/ncaa/500/158.png",
    sport: "NCAAF",
    league: "Big Ten",
  },

  // Premier League Teams
  {
    name: "Arsenal",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/359.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Aston Villa",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/362.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Bournemouth",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/349.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Brentford",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/337.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Brighton",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/331.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Chelsea",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/363.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Crystal Palace",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/384.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Everton",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/368.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Fulham",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/370.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Ipswich Town",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/373.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Leicester City",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/375.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Liverpool",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/364.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Manchester City",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/382.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Manchester United",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/360.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Newcastle United",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/361.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Nottingham Forest",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/393.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Southampton",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/376.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Tottenham",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/367.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "West Ham United",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/371.png",
    sport: "Soccer",
    league: "Premier League",
  },
  {
    name: "Wolverhampton",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/380.png",
    sport: "Soccer",
    league: "Premier League",
  },

  // La Liga Teams (Major Spanish Clubs)
  {
    name: "Real Madrid",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/86.png",
    sport: "Soccer",
    league: "La Liga",
  },
  {
    name: "Barcelona",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/83.png",
    sport: "Soccer",
    league: "La Liga",
  },
  {
    name: "Atletico Madrid",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/1068.png",
    sport: "Soccer",
    league: "La Liga",
  },
  {
    name: "Sevilla",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/243.png",
    sport: "Soccer",
    league: "La Liga",
  },
  {
    name: "Real Sociedad",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/244.png",
    sport: "Soccer",
    league: "La Liga",
  },
  {
    name: "Real Betis",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/244.png",
    sport: "Soccer",
    league: "La Liga",
  },
  {
    name: "Villarreal",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/102.png",
    sport: "Soccer",
    league: "La Liga",
  },
  {
    name: "Valencia",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/94.png",
    sport: "Soccer",
    league: "La Liga",
  },
  {
    name: "Athletic Bilbao",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/85.png",
    sport: "Soccer",
    league: "La Liga",
  },
  {
    name: "Osasuna",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/450.png",
    sport: "Soccer",
    league: "La Liga",
  },

  // Serie A Teams (Major Italian Clubs)
  {
    name: "Juventus",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/111.png",
    sport: "Soccer",
    league: "Serie A",
  },
  {
    name: "Inter Milan",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/110.png",
    sport: "Soccer",
    league: "Serie A",
  },
  {
    name: "AC Milan",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/103.png",
    sport: "Soccer",
    league: "Serie A",
  },
  {
    name: "Napoli",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/114.png",
    sport: "Soccer",
    league: "Serie A",
  },
  {
    name: "AS Roma",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/104.png",
    sport: "Soccer",
    league: "Serie A",
  },
  {
    name: "Lazio",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/112.png",
    sport: "Soccer",
    league: "Serie A",
  },
  {
    name: "Atalanta",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/103.png",
    sport: "Soccer",
    league: "Serie A",
  },
  {
    name: "Fiorentina",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/109.png",
    sport: "Soccer",
    league: "Serie A",
  },
  {
    name: "Torino",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/1237.png",
    sport: "Soccer",
    league: "Serie A",
  },
  {
    name: "Bologna",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/106.png",
    sport: "Soccer",
    league: "Serie A",
  },

  // Bundesliga Teams (Major German Clubs)
  {
    name: "Bayern Munich",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/132.png",
    sport: "Soccer",
    league: "Bundesliga",
  },
  {
    name: "Borussia Dortmund",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/124.png",
    sport: "Soccer",
    league: "Bundesliga",
  },
  {
    name: "RB Leipzig",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/11420.png",
    sport: "Soccer",
    league: "Bundesliga",
  },
  {
    name: "Bayer Leverkusen",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/131.png",
    sport: "Soccer",
    league: "Bundesliga",
  },
  {
    name: "Eintracht Frankfurt",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/125.png",
    sport: "Soccer",
    league: "Bundesliga",
  },
  {
    name: "VfL Wolfsburg",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/128.png",
    sport: "Soccer",
    league: "Bundesliga",
  },
  {
    name: "Borussia Monchengladbach",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/130.png",
    sport: "Soccer",
    league: "Bundesliga",
  },
  {
    name: "Union Berlin",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/2447.png",
    sport: "Soccer",
    league: "Bundesliga",
  },
  {
    name: "VfB Stuttgart",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/134.png",
    sport: "Soccer",
    league: "Bundesliga",
  },
  {
    name: "Schalke 04",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/124.png",
    sport: "Soccer",
    league: "Bundesliga",
  },

  // Ligue 1 Teams (Major French Clubs)
  {
    name: "Paris Saint-Germain",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/160.png",
    sport: "Soccer",
    league: "Ligue 1",
  },
  {
    name: "Marseille",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/176.png",
    sport: "Soccer",
    league: "Ligue 1",
  },
  {
    name: "Lyon",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/167.png",
    sport: "Soccer",
    league: "Ligue 1",
  },
  {
    name: "Monaco",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/174.png",
    sport: "Soccer",
    league: "Ligue 1",
  },
  {
    name: "Lille",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/163.png",
    sport: "Soccer",
    league: "Ligue 1",
  },
  {
    name: "Nice",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/2828.png",
    sport: "Soccer",
    league: "Ligue 1",
  },
  {
    name: "Lens",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/178.png",
    sport: "Soccer",
    league: "Ligue 1",
  },
  {
    name: "Rennes",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/169.png",
    sport: "Soccer",
    league: "Ligue 1",
  },
  {
    name: "Strasbourg",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/2511.png",
    sport: "Soccer",
    league: "Ligue 1",
  },
  {
    name: "Montpellier",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/273.png",
    sport: "Soccer",
    league: "Ligue 1",
  },

  // MLS Teams
  {
    name: "Inter Miami",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/15172.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "LA Galaxy",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/323.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Atlanta United FC",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/9871.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "New York City FC",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/9668.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Seattle Sounders FC",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/9726.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Portland Timbers",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/9725.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Toronto FC",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/2077.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "CF Montreal",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/2290.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "New York Red Bulls",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/399.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Chicago Fire FC",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/331.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "FC Dallas",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/336.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Houston Dynamo FC",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/882.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Columbus Crew",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/334.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "D.C. United",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/335.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Sporting Kansas City",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/397.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Colorado Rapids",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/388.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Vancouver Whitecaps FC",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/9727.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Real Salt Lake",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/396.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Minnesota United FC",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/9716.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Austin FC",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/15711.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Nashville SC",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/13041.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Charlotte FC",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/17007.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "FC Cincinnati",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/9674.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Orlando City SC",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/9723.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "New England Revolution",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/398.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "Philadelphia Union",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/9656.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "San Jose Earthquakes",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/389.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "St. Louis City SC",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/17901.png",
    sport: "Soccer",
    league: "MLS",
  },
  {
    name: "LAFC",
    logo: "https://a.espncdn.com/i/teamlogos/soccer/500/11520.png",
    sport: "Soccer",
    league: "MLS",
  },

  // Fighting Organizations / Promotions
  {
    name: "UFC",
    logo: "https://a.espncdn.com/combiner/i?img=/i/teamlogos/leagues/500/ufc.png",
    sport: "Fighting",
    league: "UFC",
  },
  {
    name: "Bellator MMA",
    logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/63/Bellator_MMA_Logo.svg/200px-Bellator_MMA_Logo.svg.png",
    sport: "Fighting",
    league: "Bellator",
  },
  {
    name: "ONE Championship",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/9/93/ONE_Championship_logo.svg/200px-ONE_Championship_logo.svg.png",
    sport: "Fighting",
    league: "ONE",
  },
  {
    name: "PFL",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/4/46/Professional_Fighters_League_logo.svg/200px-Professional_Fighters_League_logo.svg.png",
    sport: "Fighting",
    league: "PFL",
  },
  {
    name: "Rizin Fighting Federation",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/7/7f/Rizin_Fighting_Federation_logo.svg/200px-Rizin_Fighting_Federation_logo.svg.png",
    sport: "Fighting",
    league: "Rizin",
  },
  {
    name: "Cage Warriors",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/5/59/Cage_Warriors_logo.svg/200px-Cage_Warriors_logo.svg.png",
    sport: "Fighting",
    league: "Cage Warriors",
  },
  {
    name: "Boxing - Heavyweight Division",
    logo: "https://a.espncdn.com/combiner/i?img=/redesign/assets/img/icons/ESPN-icon-boxing.png&h=80&w=80&scale=crop&cquality=40",
    sport: "Fighting",
    league: "Boxing",
  },
  {
    name: "Boxing - Welterweight Division",
    logo: "https://a.espncdn.com/combiner/i?img=/redesign/assets/img/icons/ESPN-icon-boxing.png&h=80&w=80&scale=crop&cquality=40",
    sport: "Fighting",
    league: "Boxing",
  },

  // Formula 1 Teams
  {
    name: "Red Bull Racing",
    logo: "https://media.formula1.com/content/dam/fom-website/teams/2024/red-bull-racing-logo.png",
    sport: "Motorsport",
    league: "Formula 1",
  },
  {
    name: "Mercedes-AMG Petronas",
    logo: "https://media.formula1.com/content/dam/fom-website/teams/2024/mercedes-logo.png",
    sport: "Motorsport",
    league: "Formula 1",
  },
  {
    name: "Scuderia Ferrari",
    logo: "https://media.formula1.com/content/dam/fom-website/teams/2024/ferrari-logo.png",
    sport: "Motorsport",
    league: "Formula 1",
  },
  {
    name: "McLaren F1 Team",
    logo: "https://media.formula1.com/content/dam/fom-website/teams/2024/mclaren-logo.png",
    sport: "Motorsport",
    league: "Formula 1",
  },
  {
    name: "Aston Martin F1 Team",
    logo: "https://media.formula1.com/content/dam/fom-website/teams/2024/aston-martin-logo.png",
    sport: "Motorsport",
    league: "Formula 1",
  },
  {
    name: "Alpine F1 Team",
    logo: "https://media.formula1.com/content/dam/fom-website/teams/2024/alpine-logo.png",
    sport: "Motorsport",
    league: "Formula 1",
  },
  {
    name: "Williams Racing",
    logo: "https://media.formula1.com/content/dam/fom-website/teams/2024/williams-logo.png",
    sport: "Motorsport",
    league: "Formula 1",
  },
  {
    name: "Visa Cash App RB F1 Team",
    logo: "https://media.formula1.com/content/dam/fom-website/teams/2024/rb-logo.png",
    sport: "Motorsport",
    league: "Formula 1",
  },
  {
    name: "Haas F1 Team",
    logo: "https://media.formula1.com/content/dam/fom-website/teams/2024/haas-logo.png",
    sport: "Motorsport",
    league: "Formula 1",
  },
  {
    name: "Kick Sauber F1 Team",
    logo: "https://media.formula1.com/content/dam/fom-website/teams/2024/kick-sauber-logo.png",
    sport: "Motorsport",
    league: "Formula 1",
  },

  // NASCAR Teams - Using simple placeholder logos
  {
    name: "Hendrick Motorsports",
    logo: "https://logodownload.org/wp-content/uploads/2020/04/nascar-logo-2.png",
    sport: "Motorsport",
    league: "NASCAR",
  },
  {
    name: "Joe Gibbs Racing",
    logo: "https://logodownload.org/wp-content/uploads/2020/04/nascar-logo-2.png",
    sport: "Motorsport",
    league: "NASCAR",
  },
  {
    name: "Team Penske",
    logo: "https://logodownload.org/wp-content/uploads/2020/04/nascar-logo-2.png",
    sport: "Motorsport",
    league: "NASCAR",
  },
  {
    name: "Stewart-Haas Racing",
    logo: "https://logodownload.org/wp-content/uploads/2020/04/nascar-logo-2.png",
    sport: "Motorsport",
    league: "NASCAR",
  },
  {
    name: "23XI Racing",
    logo: "https://logodownload.org/wp-content/uploads/2020/04/nascar-logo-2.png",
    sport: "Motorsport",
    league: "NASCAR",
  },

  // Rugby Union Teams
  {
    name: "New Zealand All Blacks",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/4/4d/New_Zealand_national_rugby_union_team_logo.svg/200px-New_Zealand_national_rugby_union_team_logo.svg.png",
    sport: "Rugby",
    league: "International Rugby",
  },
  {
    name: "South Africa Springboks",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/e/ed/South_Africa_national_rugby_union_team_logo.svg/200px-South_Africa_national_rugby_union_team_logo.svg.png",
    sport: "Rugby",
    league: "International Rugby",
  },
  {
    name: "England Rugby",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/b/b4/England_national_rugby_union_team_logo.svg/200px-England_national_rugby_union_team_logo.svg.png",
    sport: "Rugby",
    league: "International Rugby",
  },
  {
    name: "Ireland Rugby",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/a/a2/Irish_Rugby_Football_Union_logo.svg/200px-Irish_Rugby_Football_Union_logo.svg.png",
    sport: "Rugby",
    league: "International Rugby",
  },
  {
    name: "France Rugby",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/1/12/France_national_rugby_union_team_logo.svg/200px-France_national_rugby_union_team_logo.svg.png",
    sport: "Rugby",
    league: "International Rugby",
  },
  {
    name: "Australia Wallabies",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/8/80/Australia_national_rugby_union_team_logo.svg/200px-Australia_national_rugby_union_team_logo.svg.png",
    sport: "Rugby",
    league: "International Rugby",
  },
  {
    name: "Wales Rugby",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/f/fe/Welsh_Rugby_Union_logo.svg/200px-Welsh_Rugby_Union_logo.svg.png",
    sport: "Rugby",
    league: "International Rugby",
  },
  {
    name: "Scotland Rugby",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/5/51/Scottish_Rugby_Union_logo.svg/200px-Scottish_Rugby_Union_logo.svg.png",
    sport: "Rugby",
    league: "International Rugby",
  },
  {
    name: "Argentina Pumas",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/e/e9/Argentina_national_rugby_union_team_logo.svg/200px-Argentina_national_rugby_union_team_logo.svg.png",
    sport: "Rugby",
    league: "International Rugby",
  },
  {
    name: "Crusaders",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/4/4f/Crusaders_rugby_logo.svg/200px-Crusaders_rugby_logo.svg.png",
    sport: "Rugby",
    league: "Super Rugby",
  },
  {
    name: "Blues",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/0/0e/Blues_rugby_logo.svg/200px-Blues_rugby_logo.svg.png",
    sport: "Rugby",
    league: "Super Rugby",
  },
  {
    name: "Chiefs",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/2/21/Chiefs_rugby_logo.svg/200px-Chiefs_rugby_logo.svg.png",
    sport: "Rugby",
    league: "Super Rugby",
  },
  {
    name: "Hurricanes",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/f/f2/Hurricanes_rugby_logo.svg/200px-Hurricanes_rugby_logo.svg.png",
    sport: "Rugby",
    league: "Super Rugby",
  },
  {
    name: "Brumbies",
    logo: "https://upload.wikimedia.org/wikipedia/en/thumb/b/b4/Brumbies_rugby_logo.svg/200px-Brumbies_rugby_logo.svg.png",
    sport: "Rugby",
    league: "Super Rugby",
  },
];

// Sport/League keyword mappings
const SPORT_KEYWORDS = {
  nfl: "NFL",
  "american football": "NFL",
  football: "NFL",
  nba: "NBA",
  basketball: "NBA",
  nhl: "NHL",
  hockey: "NHL",
  "ice hockey": "NHL",
  mlb: "MLB",
  baseball: "MLB",
  ncaaf: "NCAAF",
  "college football": "NCAAF",
  soccer: "Soccer",
  "premier league": "Premier League",
  epl: "Premier League",
  "la liga": "La Liga",
  spain: "La Liga",
  "serie a": "Serie A",
  italy: "Serie A",
  bundesliga: "Bundesliga",
  germany: "Bundesliga",
  "ligue 1": "Ligue 1",
  france: "Ligue 1",
  mls: "MLS",
  // Fighting sports
  fighting: "Fighting",
  ufc: "UFC",
  mma: "Fighting",
  "mixed martial arts": "Fighting",
  bellator: "Bellator",
  boxing: "Boxing",
  "one championship": "ONE",
  "one fc": "ONE",
  pfl: "PFL",
  rizin: "Rizin",
  // Motorsport
  motorsport: "Motorsport",
  racing: "Motorsport",
  "formula 1": "Formula 1",
  "formula one": "Formula 1",
  f1: "Formula 1",
  nascar: "NASCAR",
  // Rugby
  rugby: "Rugby",
  "rugby union": "Rugby",
  "rugby league": "Rugby",
  "super rugby": "Super Rugby",
  "all blacks": "International Rugby",
  springboks: "International Rugby",
};

/**
 * Search teams by name, sport, or league
 * @param {string} query - Search query
 * @param {number} limit - Max results to return
 * @returns {Array} - Array of matching teams
 */
export function searchTeams(query, limit = 50) {
  if (!query || query.trim().length < 2) {
    return [];
  }

  const queryLower = query.toLowerCase().trim();

  // Check if query matches a sport/league keyword
  let leagueFilter = null;

  for (const [keyword, league] of Object.entries(SPORT_KEYWORDS)) {
    if (queryLower === keyword || queryLower.includes(keyword)) {
      leagueFilter = league;
      break;
    }
  }

  // If a sport/league was detected, return all teams from that league
  if (leagueFilter) {
    const results = TEAMS_DATABASE.filter(
      (team) =>
        team.league === leagueFilter ||
        team.sport === leagueFilter ||
        (team.sport &&
          team.sport.toLowerCase().includes(queryLower.replace(/\s+/g, ""))) ||
        (team.league &&
          team.league.toLowerCase().includes(queryLower.replace(/\s+/g, "")))
    );

    return results.slice(0, limit);
  }

  // Otherwise, search by team name
  return TEAMS_DATABASE.filter((team) =>
    team.name.toLowerCase().includes(queryLower)
  ).slice(0, limit);
}

/**
 * Get team by exact name
 * @param {string} teamName - Team name
 * @returns {Object|null} - Team object or null
 */
export function getTeamByName(teamName) {
  return (
    TEAMS_DATABASE.find(
      (team) => team.name.toLowerCase() === teamName.toLowerCase()
    ) || null
  );
}

/**
 * Get all teams from a specific league
 * @param {string} league - League name
 * @returns {Array} - Array of teams in the league
 */
export function getTeamsByLeague(league) {
  return TEAMS_DATABASE.filter((team) => team.league === league);
}

/**
 * Get all teams from a specific sport
 * @param {string} sport - Sport name
 * @returns {Array} - Array of teams in the sport
 */
export function getTeamsBySport(sport) {
  return TEAMS_DATABASE.filter((team) => team.sport === sport);
}

const teamsDatabase = {
  TEAMS_DATABASE,
  searchTeams,
  getTeamByName,
  getTeamsByLeague,
  getTeamsBySport,
};

export default teamsDatabase;
